module.exports = __webpack_public_path__ + "static/media/acres-lazy.ecd06303.jpg";